import { useEffect } from "react";
import { addRemoveClassBody } from "../../utils";

import {
  // SecTrustContent,
  Services,
  OurTeamInfo,
} from "../../data/data-containers/HomeDemo5/data-HomeDemo5.js";

import PlatformIco from "../../data/data-containers/HomeDemo5/data-PlatformIco.json";

import SecPricesInfo from "../../data/data-containers/HomeDemo5/data-SecPricesInfo.json";

import { HomeDemo5HeroImg } from "../../utils/allImgs";

import "./style/HomeDemo5.scss";

import Header from "../../layouts/Header";
import FooterPages from "../../layouts/Footer/FooterPages";

import SecHeroSection from "../../components/HeroSection";
import SecPrices from "../../components/SecPrices";
import OurTeam from "../../components/OurTeam";

import SecTrust from "./SecTrust";
import OurServices from "./OurServices";
import OurPlatform from "./OurPlatform";
import { useTranslation } from "react-i18next";

import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

const HomeDemo4Container = () => {
  const { t } = useTranslation();

  useEffect(() => {
    addRemoveClassBody("darker");
  }, []);

  const particlesInit = async (main) => {
    console.log(main);

    // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(main);
  };

  const particlesLoaded = (container) => {
    console.log(container);
  };
  return (
    <div>
      <Header Title="ITSTCC" />

      <SecHeroSection
        ClassSec="hero-section moving-2 section-padding"
        ClassDiv="col-12 col-lg-6 col-md-12"
        specialHead="ITS Touch Consulting"
        title={t('title')}
        link1={t('button1')}
        link2={t('button2')}
        img={HomeDemo5HeroImg}
      />
      <div className="clearfix" />
      <OurPlatform data={PlatformIco} />

      <OurServices data={Services} />

      <SecPrices
        ClassSec="features section-padding-0-100"
        data={SecPricesInfo}
      />

      <OurTeam data={OurTeamInfo} ClassSpanTitle="gradient-text blue" />
      <div className="clearfix" />

      <SecTrust />
      <div className="clearfix" />

      <FooterPages ClassSpanTitle="gradient-text blue" />
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          fpsLimit: 100,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: "push",
              },
              onHover: {
                enable: false,
                mode: "repulse",
              },
              resize: true,
            },
            modes: {
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 100,
                duration: 0.9,
              },
            },
          },
          particles: {
            color: {
              value: "#CFD5D1",
              opacity: 0.06,
            },
            links: {
              color: "#CFD5D1",
              distance: 150,
              enable: true,
              opacity: 0.08,
              width: 1,
            },
            collisions: {
              enable: true,
            },
            move: {
              direction: "none",
              enable: true,
              outModes: {
                default: "bounce",
              },
              random: false,
              speed: 0.6,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                area: 800,
              },
              value: 80,
            },
            opacity: {
              value: 0.2,
            },
            shape: {
              type: "circle",
            },
            size: {
              value: { min: 1, max: 5 },
            },
          },
          detectRetina: true,
        }}
      />
    </div>
  );
};

export default HomeDemo4Container;
